module.exports = __webpack_public_path__ + "media/alarm.984d89ec.mp3";